import { cn } from "#/lib/utils";

type PageBackgroundProps = {
  className?: string;
};

export function PageBackground({ className }: PageBackgroundProps) {
  return (
    <div
      aria-hidden
      className={cn("page-background pointer-events-none fixed inset-0 -z-10", className)}
    />
  );
}
